import React from "react";
import {ROUTE_PATHS} from "../../Config/Router/Routes";
import SmallModal from "../../Components/Modal/SmallModal";

interface Props {
    show: boolean;
    onClose: () => void;
    child: {
        value: string;
        label: string;
    }
}

const ChildKnowHowToSwimModal: React.FC<Props> = ({ show, onClose, child }) => {
    return <SmallModal
        show={show}
        body={
            <>
                <p>No es posible inscribir al niño en esta actividad, ya que no has indicado si sabe nadar.</p>
                <p>Por favor, marca esta opción en la página de edición del niño para continuar con el proceso de inscripción.</p>
                <p>
                    <strong>
                        <a target="_blank"
                           href={ROUTE_PATHS.KIDS_EDIT.replace(':id', child.value)}
                        >
                            Haz click aquí para ir editar perfil de {child.label}.
                        </a>
                    </strong>
                </p>
                <br />
                <p>Una vez editado, cierra este mensaje para continuar con el proceso de inscripción.</p>
            </>
        }
        onClose={onClose}
    />;
};

export default ChildKnowHowToSwimModal;